module.exports = __webpack_public_path__ + "img/serena.d6106a46.png";